import React from "react";
import { Row, Col } from "reactstrap";
import MainCardInfo from "../components/info_cards/main_card_info";
import ManagerInfo from "../components/info_cards/manager_info";

const Organization = () => {

  return (
    <div className="page-content px-0 px-sm-2 px-xxl-4">
      <div className="ms-0">
        <Row className="m-0">
          <Col xs={12} lg={8} xxl={7} className="px-0 px-sm-3 px-md-5 py-5">
            <div className="orga_logo-lg mx-4 mx-sm-0">
              <img src="/images/orga_logo.svg" />
            </div>
            <div className="font-size-20 font-weight-500 mt-3 mx-4 mx-sm-0">
              Procraft Design Agency
            </div>
            <div className="font-size-16 text-grey mx-4 mx-sm-0">
              1849201
            </div>
            <MainCardInfo />
            <ManagerInfo />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Organization;
